import React from 'react'
import { Row } from 'react-table'

import { TableProps } from './Table.component'
import { TableRow } from './TableRow.component'

export function generateRowList<DataType extends object>(
  rows: Row<DataType>[],
  prepareRow: (row: Row<DataType>) => void,
  rowProps: Pick<TableProps<DataType>, 'onRowSelect' | 'shouldHighlight'>
) {
  return rows.map((row) => {
    prepareRow(row)
    const { original, cells, getRowProps } = row
    const originalRow: any = { ...original }

    return <TableRow {...getRowProps()} rowOriginalData={original} cells={cells} {...rowProps} key={originalRow.id} />
  })
}
